import type { PropertiesTableProps } from '../../../../shared/types'
import { StringProperties } from '../String/StringDocs'

export const NameProperties: PropertiesTableProps = {
  ...StringProperties,
}
